<div class="wrapper" [class.overflowHidden]="showAddUnits">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div class="bodyTitle">
      <app-survey-frame-list>
        <app-survey-frame-tab-template #tabs [headerTemplate]="headerTemplate" [bodyTemplate]="bodyTemplate"
          [contexts]="contexts" headerWidth="40%" bodyWidth="55%"></app-survey-frame-tab-template>
      </app-survey-frame-list>
    </div>
  </div>
</div>

<ng-template #headerTemplate let-index="index" let-building="building">
  <mat-icon style="color: red" *ngIf="getErrors(building.id)">warning</mat-icon>
  <div class="templateHeader building">
    <span class="building-key">
      <span class="bold landscape">
        <span i18n="@@general.units.building"> Building </span>
        {{ index + 1 }}
      </span>
      <span class="bold portrait">B{{ index + 1 }}</span>
      <span class="key" *ngIf="building?.lomKey">
        - {{ building?.lomKey }}
      </span>
    </span>
    <span class="address">{{
      building?.getMainAddress()?.getFullAddress()
      }}</span>
    <span class="type">{{ buildingTypeEnum[building.buildingType]
      }}<span *ngIf="building.buildingType == buildingTypeEnum.StudentHome">({{ building.studentHomeCount
        }})</span></span>
  </div>
</ng-template>

<ng-template #bodyTemplate let-index="index" let-building="building">
  <!-- Here need to come Floors Below Grond -->
  <div style="width: 25rem; margin-bottom: 2rem" class="d-flex flex-column p-3" detail>
    <div class="titleText" i18n="@@survey.inside.units.inside.title">
      Inside Units
    </div>
    <app-unit-info [unitType]="'Floors below Ground'" [isDisabled]="!isAuthCanWrite"
      [currentValue]="building.floorsBelowGround" [minValue]="0"
      (currentValueChange)="floorsBelowGroundChanged($event, building)"></app-unit-info>
    <div class="titleRow">
      <div class="subtitle-wrapper required">
        <mat-icon style="color: red" *ngIf="
        getErrors(
          building.id,
          insideSurveyInsideUnits.FLOORS_FIELD
          )
          ">warning
        </mat-icon>
        <span style="margin-bottom: 0;" class="titleText" i18n="@@general.floors">Floors</span>
      </div>
      <div>
        <span class="titleText" i18n="@@general.totalUnits">Total Units</span>
        <span class="titleTextRow"> (LU, BU & SU)</span>
      </div>
    </div>
    <div *ngFor="
    let floorProperty of building.floors | keyvalue: valueAscOrder;
    let j = index
    " [ngClass]="{
      'invalid-answer-input':
      getErrors(
        building.id,
          insideSurveyInsideUnits.FLOORS_FIELD
          )
    }">

      <app-unit-info style="margin-bottom: 0.5rem" [isDisabled]="!isAuthCanWrite" [unitType]="floorProperty.key"
        [minValue]="0" [(currentValue)]="floorProperty.value.totalNumberOfUnits"></app-unit-info>
    </div>
    <div class="totalUnitFrame">
      <div i18n="@@general.totalUnitsInside">
        TOTAL UNITS (sum of inside units)
      </div>
      <div style="font-size: 16px">{{ totalUnits(building) }}</div>
    </div>
    <div class="totalUnitFrame">
      <div i18n="@@general.totalUnitsOutside">
        TOTAL UNITS (sum of outside units)
      </div>
      <div style="font-size: 16px">{{ totalUnitsOutside(building) }}</div>
    </div>
  </div>
</ng-template>